import { render, staticRenderFns } from "./PieChart.vue?vue&type=template&id=2110949c&"
import script from "./PieChart.vue?vue&type=script&lang=js&"
export * from "./PieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/renan/Fontes/OngFacil/Edital-Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2110949c')) {
      api.createRecord('2110949c', component.options)
    } else {
      api.reload('2110949c', component.options)
    }
    module.hot.accept("./PieChart.vue?vue&type=template&id=2110949c&", function () {
      api.rerender('2110949c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/charts/PieChart.vue"
export default component.exports